"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = VectorDraw;

var _VectorDraw = require("@adobe/react-spectrum-workflow/dist/VectorDraw.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function VectorDraw(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_VectorDraw.A4uVectorDraw, null));
}